export const SATIN_COLUMN_PALETTE = [
  { stroke: "#16a34a", text: "#166534", border: "#86efac", soft: "#f0fdf4" },
  { stroke: "#ea580c", text: "#9a3412", border: "#fdba74", soft: "#fff7ed" },
  { stroke: "#9333ea", text: "#6b21a8", border: "#d8b4fe", soft: "#faf5ff" },
  { stroke: "#e11d48", text: "#9f1239", border: "#fda4af", soft: "#fff1f2" },
  { stroke: "#0891b2", text: "#155e75", border: "#67e8f9", soft: "#ecfeff" },
  { stroke: "#ca8a04", text: "#854d0e", border: "#fde047", soft: "#fefce8" },
];

export const getSatinColumnColor = (index) =>
  SATIN_COLUMN_PALETTE[index % SATIN_COLUMN_PALETTE.length];
